// Cambios sin guardar de «Ampliación» (verificación de ventas del 27-oct-2026: el vendedor tecleaba costos, cambiaba de pestaña
// y se perdían en silencio). La forma con cambios vive AQUÍ, por cotización, fuera de la pantalla: cambiar de pestaña (o volver
// con «Atrás», que no se puede detener) no la pierde, la pestaña PDF sabe que hay cambios sin guardar y, mientras haya alguno,
// cerrar o recargar la página pregunta (beforeunload). Al cambiar de pestaña DENTRO de la app, la pantalla pregunta
// «Guardar / Descartar» (ruteo.tsx → ponerGuardia). Se olvida al guardar, al descartar o si lo guardado cambió.
import { useSyncExternalStore } from 'react';
import type { FormaAmpliacion } from './ampliacion.ts';

export interface PendienteAmpliacion {
  forma: FormaAmpliacion;
  /** JSON de las piezas guardadas sobre las que se tecleó: si lo guardado cambia, esta forma ya no es de ahí. */
  base: string;
  /** Cuántos datos cambian (0 si lo tecleado todavía no sirve para guardar). */
  cambios: number;
}

const pendientes = new Map<string, PendienteAmpliacion>();
const oyentes = new Set<() => void>();

const alSalir = (e: BeforeUnloadEvent) => {
  e.preventDefault();
  // Los navegadores de antes piden returnValue para enseñar su «¿Salir del sitio?»
  e.returnValue = '';
};

function avisar(): void {
  if (typeof window !== 'undefined') {
    if (pendientes.size) window.addEventListener('beforeunload', alSalir);
    else window.removeEventListener('beforeunload', alSalir);
  }
  for (const f of oyentes) f();
}

/** La base con que se compara (las piezas guardadas). */
export const basePendiente = (piezas: unknown): string => JSON.stringify(piezas ?? null);

export function pendienteAmpliacion(id: string): PendienteAmpliacion | null {
  return pendientes.get(id) ?? null;
}

export function ponerPendienteAmpliacion(id: string, p: PendienteAmpliacion | null): void {
  if (p) pendientes.set(id, p);
  else if (!pendientes.delete(id)) return;
  avisar();
}

/** La forma con cambios sin guardar de esa cotización, si sigue siendo sobre lo guardado HOY (`piezas`); si no, null. */
export function usarPendienteAmpliacion(id: string, piezas: unknown): PendienteAmpliacion | null {
  const p = useSyncExternalStore(
    (cb) => {
      oyentes.add(cb);
      return () => oyentes.delete(cb);
    },
    () => pendientes.get(id) ?? null,
    () => null,
  );
  return p && p.base === basePendiente(piezas) ? p : null;
}

/** ¿Hay algo tecleado y sin guardar en alguna cotización? (la banda de versión nueva pregunta antes de recargar) */
export function hayPendientes(): boolean {
  return pendientes.size > 0;
}

/** Para las pruebas y al salir de la sesión. */
export function olvidarPendientes(): void {
  pendientes.clear();
  avisar();
}
